
import React from 'react';
import { Container } from 'react-bootstrap';
import InvoiceGenerator from '../components/InvoiceGenerator';

const InvoiceGeneratorPage = () => {
  return (
    <section className="py-5">
      <Container>
        <InvoiceGenerator />
      </Container>
    </section>
  );
};

export default InvoiceGeneratorPage;
